import React from "react";
import {Dialog, IconButton} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import "./ImageLightbox.css";

export default function ImageLightbox({src, alt, onClose}) {
  return (
    <Dialog open={!!src} onClose={onClose} maxWidth="md">
      <div className="image-lightbox">
        <IconButton className="image-lightbox-close" size="small" onClick={onClose}>
          <CloseIcon fontSize="small"/>
        </IconButton>
        {!!src && <img src={src} alt={alt || ''} className="image-lightbox-image"/>}
      </div>
    </Dialog>
  );
}
